<div class="banner">
  <h1 class="banner-text">Gelieve u aan en af te melden voor uw afspraken!</h1>
</div>

<div class="buttons">
  <app-custom-btn customClass="button pattern shadow larger" [routerLink]="'/main/register'">
    <mat-icon>dialpad</mat-icon>
    Aanmelden
    <mat-icon>person_add</mat-icon>
  </app-custom-btn>
  <app-custom-btn customClass="button pattern shadow larger" [routerLink]="'/main/unregister'">
    <mat-icon>clear</mat-icon>
    Afmelden
    <mat-icon>meeting_room</mat-icon>
  </app-custom-btn>
</div>
